import {createAction} from "typesafe-actions";
import {TabErrorInterface} from "../../reducers/tabs/reducer";

export const setErrorInTab = createAction('SET_TABS_ERRORS')<TabErrorInterface>();
export const clearErrorInTabs = createAction('CLEAR_TABS_ERRORS')();

export const saveForms = createAction('SET_SAVE_FORMS')<{visible:boolean}>()
